import React, { FunctionComponent } from 'react';
import './heroCarouselScrollSymbol.scss';
import { iconSize } from '../../../constants/icon.constants';
import Icon from '../../@shared/icon';
import scrolls from 'scrolls.js';

const HeroCarouselScrollSymbol: FunctionComponent<{}> = () => {
  const scroll = (): void => scrolls('.carousel-wrapper+*');

  return (
    <div className="scroll-symbol" onClick={scroll}>
      <Icon iconName="arrow-chevron-down" color="white" size={iconSize.xlg} />
    </div>
  );
};

export default HeroCarouselScrollSymbol;
